/*
|--------------------------------------------------------------------------
! All Your Application Navigations Paths Will Be Here
|--------------------------------------------------------------------------
*/
export const PUBLIC_PATH = "/";
// export const LANDING_PATH = '/';
export const LOGIN_PATH = "/login";
export const REGISTER_PATH = "signup";
export const FORGETPASSWORD = "/password/reset";
export const RESETPASSWORD = "/password/reset/confirm/:uid/:token";
export const AFTERREGISTER = "/verificationMail";
export const SSO_CALLBACK_PATH = "/sso/callback";


/**
 * @readonly
 * ! PROTECTED ROUTES
 */
export const ACCEUIL_PATH = "/";
export const PRODUCTS_PATH = "/dossier-client";
export const CLIENTS_PATH = "/clients";

// DOSSIER CLIENT
export const DOSSIER_PATH = "/client/:clientID";
export const SOLDES = "";
export const CLIENT = "client/";
export const DETAIL_CLIENTS_PATH = ":id/";
export const DEPENSE = "depenses/";
export const ADD_DEPENSE = "add-depense/";
export const DETAIL_DEPENSE = "detailDepense/:id";

// VENTE
export const VENTE = "ventes/";
export const ADD_VENTE = "add-vente/";
export const DETAIL_VENTE = ":id/";

//raprochement
export const ADD_RAPPROCHEMENT = "add-rapprochement";

// PRODUCT
export const PRODUCT = "products/";
export const ADD_PRODUCT = "add-product/";
export const DETAIL_PRODUCT = ":id/";

// TRANSACTIONS
export const TRANSACTION = "transactions/";

// TRANSACTIONS
export const BALANCE = "balance/";
export const BALANCE_GENERAL = "balance/generale/";
export const GENERALE = "generale/";
export const BALANCE_AUXILIAIRE = "balance/auxiliaire/";
export const AUXILIAIRE = "auxiliaire/";
export const BALANCE_AGEE = "balance/agee/";
export const AGEE = "agee/";
export const BILAN = "bilan-comptable/";

// CREANCES
export const CREANCES = "creances/"
export const ADD_CREANCE = "add-creance/";
export const DETAIL_CREANCE = ":id/";
export const HISTORIQUE_CREANCE = "historique-creance/:id/";
export const PAIEMENT_CREANCE = "paiement-creance/";

// compte de résultats
export const COMPTE_RESULTATS = "compte-resultats/";

export const TVA = "tva/";

// fournisseur
export const FOURNISSEURS = "fournisseurs/";
export const DETAIL_FOURNISSEURS_PATH = ":id/";
//parametre
export const PARAMETRE_PATH = "parametre/";

// CREDIT
export const CREDIT_PATH = "credit/";

// DETTE
export const DETTE_PATH = "dettes/";
export const ADD_DETTE = "add-dette/";
export const DETAIL_DETTE = ":id/";
export const PAIEMENT_DETTE = "paiement-dette/";
export const HISTORIQUE_DETTE = "historique-dette/:id/";

// FACTURE
export const FACTURE = "facture/";

// FACTURATION (factures & devis generes)
export const FACTURATION = "facturation/";

// PIECES COMPTABLES & GED
export const PIECES_COMPTABLES = "pieces-comptables/";

//CABINET
export const COLLABORATEURS = "/gestion_utilisateurs/";
export const PARAMETRES_CABINET = "/parametres_cabinet/";
export const ROLE_AND_PERMISSIONS = "/role_and_permissions/";
export const ADD_ROLE = "nouveau_role/";
export const DETAIL_COLLABORATEURS_PATH = ":id/";
export const GENERATE_ETATS = "generate-etats/";
export const SAISIE_MANUELLE = "saisie-manuelle/";
export const SAGE = "sage/";
export const GESTION_TIERS = "gestion-tiers/";
export const IMPORT_FICHIERS = "import-fichers/";

export const FOURNISSEURS_CABINET = "fournisseurs/";
export const DETAIL_FOURNISSEURS_PATH_CABINET = ":id/";
export const CLIENT_CABINET = "client/";
export const DETAIL_CLIENTS_PATH_CABINET = ":id/";
export const SALARIES_CABINET = "salaries/";
export const DETAIL_SALARIES_PATH_CABINET = ":id/";

//SAGE
export const CODE_JOURNAL = "/code_journaux";
export const DETAIL_CODE_JOURNAL_PATH = ":id/";

//COMPTE COMPTABILITE
export const COMPTE_COMPTABILITE = "compte_paiement/";
export const DETAIL_COMPTE_COMPTABILITE_PATH = ":id/";

// journal_achat
export const JOURNAL_ACHAT = "journal_achat/";
export const JOURNAL_ACHAT_PATH = ":id/";
export const SAISIE_PATH = "comptabilite/saisie/";
export const DISPLAYJOURNAL_PATH = "journal_achat/display_journal/";

export const GRAND_LIVRE = "grand_livre/";
export const BALANCE_GENERALE = "balance/";

export const PARAMETRES_DOSSIER = "parametres_dossier/";

// Comptabilite
export const COMPTABILITE = "comptabilite/";
export const FISCALITE = "fiscalite/";
export const RAPPROCHEMENT_PIECES = "rapprochement-pieces/";
export const PLAN_COMPTABLE = "comptabilite/plan-comptable/";
export const ASSISTANT_IA = "assistant-ia/";
export const ASSISTANT_IA_OPERATION = "assistant-ia/operation/";

export const PARTAGE_DOSSIER = "partage-dossier/";
export const JOURNAL_ACTIVITE = "journal-activite/";
export const MIGRATION_ODOO = "migration-odoo/";

// OCR
export const OCR = "ocr/";
export const OCR_VIEW_INVOICE = "ocr/view-invoice";

export const DESACTIVES_PATH = "/dossier-desactives";
export const ARCHIVE_PATH = "/dossier-archives";

/**
 * @readonly
 * ! NOT FOUND ROUTE
 */
export const NOTFOUND_PATH = "*";

// Mobile Path
export const TRANSAC_PATH = "/transactionsmob";
export const CAISSEMOBILE_PATH = "/caissemob";
export const BANQUEMOBILE_PATH = "/banquemob";
export const WAVEMOBILE_PATH = "/wavemob";
export const OMMOBILE_PATH = "/orangemoneymob";
